import {
  Box,
  Button,
  Center,
  HStack,
  Select,
  StackProps,
  useClipboard,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router";
import { useQueryParams } from "use-query-params";
import { ColorModeSwitcher } from "../components/shared/ColorModeSwitcher";
import { Logo } from "../components/shared/Logo";
import { MaterialIcon } from "../components/shared/MaterialIcon";
import { PublicDashboardUrlParams, Routes } from "../constants";
import {
  DEFAULT_PUBLIC_REGISTRY,
  PUBLIC_REGISTRY_OPTIONS,
} from "../routes/stats/models/PublicRegistry";

interface IProps extends StackProps {}

export const PageHeaderPublic = (props: IProps) => {
  const { ...rest } = props;

  let [selectRegistryValue, setSelectRegistryValue] = React.useState(
    DEFAULT_PUBLIC_REGISTRY.value
  );
  let [isShowSwitch, setIsShowSwitch] = React.useState<boolean>(false);

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useQueryParams();

  const { onCopy, value } = useClipboard(window.location.href);

  const toast = useToast();

  const handleOnChangeRegistry = (registryName) => {
    setSearchParams({ [PublicDashboardUrlParams.registry]: registryName });
  };

  const handleOnNotify = () => {
    window.open("https://www.geneial.com/newsletter/", "_blank");
  };

  const handleOnShare = () => {
    onCopy();
    toast({
      title: "Copied url for this page",
      description: value,
      status: "info",
      duration: 2000,
      isClosable: true,
    });
  };
  const handleOnLogin = () => {
    navigate(Routes.AuthSignIn);
  };

  React.useEffect(() => {
    const registryFromParams = searchParams[PublicDashboardUrlParams.registry];
    const switchFromParams = searchParams[PublicDashboardUrlParams.switch];

    const foundRegistry = PUBLIC_REGISTRY_OPTIONS.find(
      (regOption) => regOption.value === registryFromParams
    );

    if (foundRegistry) {
      setSelectRegistryValue(foundRegistry.value);
    } else {
      handleOnChangeRegistry(DEFAULT_PUBLIC_REGISTRY.value);
    }

    if (switchFromParams) {
      setIsShowSwitch(switchFromParams);
    }
  }, [searchParams]);

  return (
    <HStack
      justify={"space-between"}
      spacing={{ base: "4", lg: "24" }}
      px="12"
      py="8"
      shadow="sm"
      bg="bg.main"
      borderBottom={"1px"}
      borderColor="border"
      w="full"
      alignItems={"center"}
      {...rest}
    >
      <Center>
        <Logo.Base h="12" />
      </Center>
      <HStack flex={1} justifyContent="flex-end" spacing={8}>
        {isShowSwitch && (
          <Box>
            <Select
              value={selectRegistryValue}
              onChange={(e) => handleOnChangeRegistry(e.target.value)}
            >
              {PUBLIC_REGISTRY_OPTIONS.map((regOption) => (
                <option key={regOption.value} value={regOption.value}>
                  {regOption.title}
                </option>
              ))}
            </Select>
          </Box>
        )}
        <Button
          variant={"outline"}
          colorScheme={"primary"}
          leftIcon={<MaterialIcon name="notifications" fontSize="1rem" />}
          onClick={handleOnNotify}
        >
          Join our newsletter
        </Button>
        <Button
          colorScheme={"primary"}
          onClick={handleOnShare}
          leftIcon={
            <MaterialIcon
              name="content_copy"
              variant="outline"
              fontSize="1rem"
            />
          }
        >
          Copy url
        </Button>
        <Button
          colorScheme={"accent"}
          onClick={handleOnLogin}
          rightIcon={
            <MaterialIcon name="login" variant="outline" fontSize="1rem" />
          }
        >
          Login
        </Button>

        <ColorModeSwitcher></ColorModeSwitcher>
      </HStack>
    </HStack>
  );
};
